import { DriverInfo } from "modules/drivers";

const DriverInfoPage = () => {
  return <DriverInfo />;
};

export default DriverInfoPage;
